import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import ListCard from '../../../List/ListCard';
import StandardMenuContent from './StandardMenuContent';
import ScrollableMenuContent from './ScrollableMenuContent';
import { setRefs } from '../../../../utils/refHelpers';
import { hasSubmenus } from '../../helpers';
import StandardMenuContext from './context';
import { StandardMenuType } from './types';
import s from './StandardMenu.scss';
const StandardMenu = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { id, items, className, label, scrollable = false, lightText, hideCheckIcon, menuClassName, itemClassName, groupClassName, labelClassName, withHoverEffect = true, withCardWrapper = true, withPaddings = true, withItemHorizontalPaddings = true, withScrollableArrows = false, menuType = StandardMenuType.DROPDOWN, onSelect, innerRef, children, itemsFillContainerWidth, role } = _param, restProps = _object_without_properties(_param, [
        "id",
        "items",
        "className",
        "label",
        "scrollable",
        "lightText",
        "hideCheckIcon",
        "menuClassName",
        "itemClassName",
        "groupClassName",
        "labelClassName",
        "withHoverEffect",
        "withCardWrapper",
        "withPaddings",
        "withItemHorizontalPaddings",
        "withScrollableArrows",
        "menuType",
        "onSelect",
        "innerRef",
        "children",
        "itemsFillContainerWidth",
        "role"
    ]);
    const hasPaddings = withPaddings && !label;
    // TODO: submenus don't work with scrollable
    const isScrollable = (scrollable || !!label) && !hasSubmenus(items);
    const contentProps = {
        id,
        items,
        className: menuClassName,
        groupClassName,
        itemClassName: c(itemClassName, s['menu-item']),
        hideCheckIcon,
        withHoverEffect,
        lightText,
        onSelect,
        role
    };
    const content = /*#__PURE__*/ React.createElement(React.Fragment, null, isScrollable ? /*#__PURE__*/ React.createElement(ScrollableMenuContent, _object_spread({
        label: label,
        labelClassName: c(labelClassName, s['label']),
        withScrollableArrows: withScrollableArrows
    }, contentProps)) : /*#__PURE__*/ React.createElement(StandardMenuContent, contentProps), children);
    return /*#__PURE__*/ React.createElement(StandardMenuContext.Provider, {
        value: {
            menuType,
            role
        }
    }, withCardWrapper ? /*#__PURE__*/ React.createElement(ListCard, _object_spread({
        className: c(s['root'], className),
        innerRef: (node)=>setRefs([
                ref,
                innerRef
            ], node)
    }, restProps), content) : /*#__PURE__*/ React.createElement("div", _object_spread({
        className: c(s['root'], hasPaddings && s['with-paddings'], // TODO: can this be ignored?
        !withItemHorizontalPaddings && s['without-item-horizontal-paddings'], className),
        ref: (node)=>setRefs([
                ref,
                innerRef
            ], node)
    }, restProps), content));
});
StandardMenu.displayName = 'StandardMenu';
export default StandardMenu;
